module.exports = __webpack_public_path__ + "assets/img/05.canal-server-3.6c900d9a.png";